export default __webpack_public_path__ + "static/media/Minicard_Ad.f98573d0.svg";